var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._g(_vm._b({staticClass:"app-card-code"},'v-card',_vm.$attrs,false),_vm.$listeners),[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"demo-content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }